<script setup lang="ts">
import type { IIconProps } from './types'
import type { TIconSizes, TSizes } from '@/ui/ts/types/Sizes'
import { ICON_SIZES, SIZES } from '@/ui/ts/types/Sizes'
import { isDark } from '@/lib/utils'

const props = defineProps<IIconProps>()

const sizeClassMap: Record<TIconSizes, string> = {
    xs: 'size-4 min-w-4',
    s: 'size-5 min-w-5',
    m: 'size-6 min-w-6',
    l: 'size-8 min-w-8',
}

function getSizeClasses(size: TSizes | TIconSizes): string {
    let iconSize: TIconSizes

    if (Object.values(SIZES).includes(size as TSizes)) {
        iconSize = ICON_SIZES[size as TSizes]
    } else {
        iconSize = size as TIconSizes
    }

    return sizeClassMap[iconSize] || ''
}
</script>

<template>
    <span
        class="align-bottom"
        :class="[`i-gpp-${props.name}`, getSizeClasses(props.size), isDark(props.dark)]"
        data-gpp-tools-ui
    />
</template>
